import { ADJUSTMENT_EXPIRED } from 'yoda-site-components/lib/actionTypes/AdjustmentActionTypes';

function UpdateAdjustmentStatusReducer(state = {}, action) {
    switch (action.type) {
        case ADJUSTMENT_EXPIRED:
            return action.payload;
        default:
            return state;
    }
}

UpdateAdjustmentStatusReducer.reducerName = 'updateAdjustmentStatus';
export default UpdateAdjustmentStatusReducer;
